import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UserFilter } from '../../models/user-filter.model';
import { Subscription } from 'rxjs';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'morva-public-delete',
  templateUrl: './public-delete.component.html',
  styleUrl: './public-delete.component.scss'
})
export class PublicDeleteComponent implements OnInit {
  item: string;
  id: string;
  constructor(
    private dialogRef: NbDialogRef<any>){}
  

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close(false);
  }

  onDeleteClick() {
    this.dialogRef.close(true);
  }

}